import { render, staticRenderFns } from "./Cell.vue?vue&type=template&id=c454c6e6&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=js"
export * from "./Cell.vue?vue&type=script&lang=js"
import style0 from "./Cell.vue?vue&type=style&index=0&id=c454c6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c454c6e6",
  null
  
)

export default component.exports